import ApiService from "../../commons/services/ApiService";

const apiService = new ApiService();

export default class HallieAPI {

    URI_V1 = "/v1/hallie"

    sendMessage = async (data: any) => {
        return await apiService.post(`${this.URI_V1}`, data);
    };

}
